import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

export const SEQUENCE_COLUMNS: Record<string, DataTypeColumn> = {
  seq_membership_status: {
    header: 'Sequence Status',
    group: 'Email Sequence',
  },
  seq_emails_sent: {
    header: 'Emails Sent',
    group: 'Email Sequence',
  },
  seq_last_email: {
    header: 'Last Email',
    group: 'Email Sequence',
  },
  seq_sequence_step: {
    header: 'Sequence Step',
    group: 'Email Sequence',
  },
  seq_reply_status: {
    header: 'Reply Status',
    group: 'Email Sequence',
  },
  seq_opened: {
    header: 'Opened',
    group: 'Email Sequence',
  },
}

export const SEQUENCE_SORTABLE_FIELDS = [
  'seq_emails_sent',
  'seq_last_email',
  'seq_membership_status',
]
